import React from "react";
import { Button, Label, Input } from "@revvsales/components";

class MergeGroups extends React.Component {
  state = {
    mergeGroupID: null,
    mergeGroupName: "",
    mergeGroupMetadata: false,
  };

  componentDidMount() {
    const { mergeGroup } = this.props;
    this._setMergeGroup(mergeGroup);
    if (this.groupName) {
      this.groupName.focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mergeGroup !== this.props.mergeGroup) {
      this._setMergeGroup(this.props.mergeGroup);
    }
  }

  _setMergeGroup = mergeGroup => {
    if (mergeGroup && mergeGroup instanceof Object) {
      const { id, label, total } = mergeGroup;
      this.setState({
        mergeGroupID: id,
        mergeGroupName: label,
        mergeGroupMetadata: total,
      });
    }
  };

  _updateMergeGroupName = event => {
    this.setState({ mergeGroupName: event.target.value });
  };

  _updateMergeGroupMetadata = event => {
    this.setState({ mergeGroupMetadata: event.target.checked });
  };

  _rejectMergeGroupName = () => {
    this.setState({
      mergeGroupName: "",
      mergeGroupMetadata: false,
    });
    this.props.closePopUp();
  };

  _submit = () => {
    const { handleMergeGroup } = this.props;
    const { mergeGroupID, mergeGroupName, mergeGroupMetadata } = this.state;

    handleMergeGroup(mergeGroupID, mergeGroupName, mergeGroupMetadata);
  };

  render() {
    const { mergeGroupName, mergeGroupMetadata } = this.state;

    return (
      <div className="revv-modal-content">
        <div className="revv-modal-contenttitle">
          {this.props.isEditMode ? "Edit group name" : "Merge groups"} in deal
          table view
        </div>
        <div className="revv-modal-contentbody">
          <div className="revv-form-items">
            <Label className="revvform-label" htmlFor="label-name">
              Group name
            </Label>
            <Input
              type="text"
              placeholder="Enter Group Name here"
              onChange={this._updateMergeGroupName}
              value={mergeGroupName}
              inputRef={input => {
                this.groupName = input;
              }}
              data-test="mergegrups-text-input"
            />
          </div>

          <div className="revv-form-items">
            <Input
              type="checkbox"
              onChange={this._updateMergeGroupMetadata}
              checked={mergeGroupMetadata}
              data-test="mergegrups-checkbox-input"
            />
            <Label htmlFor="label-name">
              Calculate and display group subtotal
            </Label>
          </div>
        </div>
        <div className="revv-modal-footer">
          <div className="revv-modal-footerbtns">
            <Button
              className="btn-transparent"
              onClick={this._rejectMergeGroupName}
              data-test="mergegrups-discard-btn">
              Discard
            </Button>
            <Button
              disabled={!(mergeGroupName && mergeGroupName.length > 0)}
              onClick={this._submit}
              data-test="mergegroups-merge-btn">
              {this.props.isEditMode ? "Edit group" : "Merge group"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default MergeGroups;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/MergeGroups.js